import React from 'react';
import { Modal, Button, Text, Stack, Group, Badge, Alert, List, ThemeIcon } from '@mantine/core';
import { useSubscription } from '../contexts/SubscriptionContext';

const UpgradeModal = () => {
  const { showUpgradeModal, upgradeContext, closeUpgradeModal } = useSubscription();

  const getFeatureDisplayName = (feature) => {
    const names = {
      personas: 'Personas',
      groups: 'Groups',
      saved_items: 'Saved Items',
      wishlists: 'Wish Lists'
    };
    return names[feature] || feature;
  };

  return (
    <Modal
      opened={showUpgradeModal}
      onClose={closeUpgradeModal}
      title={
        <Group gap="sm">
          <Text size="xl" fw={700}>Upgrade to Pro</Text>
          <Badge size="lg" variant="gradient" gradient={{ from: 'yellow', to: 'orange' }}>
            ⭐ PRO
          </Badge>
        </Group>
      }
      size="lg"
      centered
    >
      <Stack gap="lg">
        {/* Limit Reached Alert */}
        {upgradeContext && (
          <Alert color="orange" variant="light" icon={<span>🔒</span>}>
            <Text size="sm" fw={500}>
              {upgradeContext.message || `You've reached the free tier limit for ${getFeatureDisplayName(upgradeContext.feature)}`}
            </Text>
          </Alert>
        )}

        {/* Pro Benefits */}
        <Stack gap="md">
          <Text size="lg" fw={600}>Unlock Pro Benefits:</Text>
          
          <List
            spacing="sm"
            size="sm"
            icon={
              <ThemeIcon color="teal" size={20} radius="xl">
                ✓
              </ThemeIcon>
            }
          >
            <List.Item>
              <Text fw={500}>Unlimited Personas</Text>
              <Text size="xs" c="dimmed">Create as many gift recipient profiles as you need</Text>
            </List.Item>
            
            <List.Item>
              <Text fw={500}>Unlimited Groups</Text>
              <Text size="xs" c="dimmed">Organize group gifts without limits</Text>
            </List.Item>
            
            <List.Item>
              <Text fw={500}>AI-Powered Persona Builder</Text>
              <Text size="xs" c="dimmed">Get intelligent attribute suggestions for personas</Text>
            </List.Item>
            
            <List.Item>
              <Text fw={500}>Unlimited Saved Items & Wish Lists</Text>
              <Text size="xs" c="dimmed">Save and organize unlimited gift ideas</Text>
            </List.Item>
            
            <List.Item>
              <Text fw={500}>Advanced AI Features</Text>
              <Text size="xs" c="dimmed">Access AI gift concierge and smart recommendations</Text>
            </List.Item>
            
            <List.Item>
              <Text fw={500}>Priority Support</Text>
              <Text size="xs" c="dimmed">Get help when you need it most</Text>
            </List.Item>
          </List>
        </Stack>

        {/* Pricing (placeholder) */}
        <Stack gap="xs" p="md" style={{ 
          background: 'linear-gradient(135deg, rgba(255,193,7,0.1) 0%, rgba(255,152,0,0.1) 100%)',
          borderRadius: '8px'
        }}>
          <Group justify="space-between" align="center">
            <div>
              <Text size="xl" fw={700}>$9.99/month</Text>
              <Text size="sm" c="dimmed">or $99/year (save 17%)</Text>
            </div>
            <Badge size="lg" color="orange">Limited Time Offer</Badge>
          </Group>
          <Text size="xs" c="dimmed" ta="center">
            Cancel anytime • 30-day money-back guarantee
          </Text>
        </Stack>

        {/* Action Buttons */}
        <Group grow>
          <Button
            size="lg"
            variant="gradient"
            gradient={{ from: 'yellow', to: 'orange', deg: 90 }}
            leftSection={<span>⭐</span>}
            style={{ boxShadow: '0 4px 12px rgba(255,152,0,0.3)' }}
            onClick={() => {
              // TODO: Navigate to payment/upgrade page
              alert('Payment integration coming soon!');
              closeUpgradeModal();
            }}
          >
            Upgrade to Pro
          </Button>
          
          <Button
            size="lg"
            variant="outline"
            onClick={closeUpgradeModal}
          >
            Maybe Later
          </Button>
        </Group>

        <Text size="xs" c="dimmed" ta="center">
          By upgrading, you agree to our Terms of Service and Privacy Policy
        </Text>
      </Stack>
    </Modal>
  );
};

export default UpgradeModal;
